import * as React from 'react'
import { Link } from 'react-router-dom'
import { showCookiePreferences } from '../cookieConsent'
import { COMPANY_ADDRESS_LINE, COMPANY_INFO } from '../companyInfo'

export function LegalFooter() {
  return (
    <footer
      className="legal-footer"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '0.5rem',
        padding: '0.75rem 1rem',
        fontSize: '0.85rem',
        color: '#6b7280',
        borderTop: '1px solid #e5e7eb',
        background: '#fafafa',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '1rem',
          justifyContent: 'center',
        }}
      >
        <Link to="/kontakt">Dane kontaktowe</Link>
        <Link to="/terms">Regulamin</Link>
        <Link to="/privacy">Polityka prywatności</Link>
        <Link to="/dpa">Umowa o przetwarzaniu danych</Link>
        <button
          type="button"
          onClick={showCookiePreferences}
          style={{ background: 'none', border: 'none', color: '#2563eb', cursor: 'pointer', padding: 0 }}
        >
          Ustawienia cookies
        </button>
      </div>
      <div style={{ textAlign: 'center' }}>
        {COMPANY_INFO.shortName}, {COMPANY_ADDRESS_LINE} · NIP {COMPANY_INFO.nip} ·{' '}
        <a href={`tel:${COMPANY_INFO.phoneHref}`}>{COMPANY_INFO.phone}</a> ·{' '}
        <a href={`mailto:${COMPANY_INFO.email}`}>{COMPANY_INFO.email}</a>
      </div>
    </footer>
  )
}
